/**
 * A dictionary with all the module routes.
 * @type {AuthRoutes}
 * @ngesdoc constant
 * @ngname AUTH_ROUTES
 * @ngmodule auth
 */
const authRoutes = {
  auth: '/auth',
  login: '/login',
  success: '/success',
  unauthorized: '/unauthorized',
  rememberPassword: '/remember-password',
  resetPassword: '/reset-password/:code/:ref?',
  createPassword: '/create-password/:code/:ref?',
};

export default authRoutes;
